module.exports = __webpack_public_path__ + "static/media/19ESCAP51.00cae62d.jpg";